import { DOCUMENT, Injectable, inject } from '@angular/core';

import { HAND_OVER_FRAGMENT_KEY } from '../constant/hand-over.constant';
import { LOCAL_STORAGE_KEY } from '../constant/local-storage.constant';

@Injectable({ providedIn: 'root' })
export class TokenStoreService {
    private readonly document = inject(DOCUMENT);

    read(): string | null {
        return this.storage?.getItem(LOCAL_STORAGE_KEY.AUTH_TOKEN) ?? null;
    }

    save(token: string): void {
        this.storage?.setItem(LOCAL_STORAGE_KEY.AUTH_TOKEN, token);
    }

    clear(): void {
        this.storage?.removeItem(LOCAL_STORAGE_KEY.AUTH_TOKEN);
    }

    // Keeps the token Google's callback put in the address, then takes it out of the address.
    saveHandedOverToken(): void {
        const view = this.document.defaultView;
        if (!view) return;

        const handedOver = new URLSearchParams(view.location.hash.slice(1)).get(
            HAND_OVER_FRAGMENT_KEY,
        );
        if (!handedOver) return;

        this.save(handedOver);
        view.history.replaceState(null, '', view.location.pathname + view.location.search);
    }

    private get storage(): Storage | undefined {
        return this.document.defaultView?.localStorage;
    }
}
